export const validateEmail = (email) => {
  var re = //eslint-disable-next-line
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export function formatNumberAsThousands(number) {
  const formatter = new Intl.NumberFormat("es-CL", {
    maximumFractionDigits: 3,
    minimumFractionDigits: 3,
    style: "decimal",
  });

  return formatter.format(number / 1000).replace(/,/g, ".");
}
